/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Display_DisconnectedInputs */

const vi_customer_display_disconnected = /** @type {(inputs: Customer_Display_DisconnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mất kết nối`)
};

/**

* @param {Customer_Display_DisconnectedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_display_disconnected = /** @type {((inputs?: Customer_Display_DisconnectedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Display_DisconnectedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_display_disconnected(inputs)
});